export default "__VITE_ASSET__DZ1OHkok__"